<template>
  <input type="number" name="place" min="1" max="20" value="1" v-on:input="onChange" />
</template>



<script>
import jQuery from "jquery";
window.jQuery = jQuery;
require("jquery.nice-number/dist/jquery.nice-number.css");
require("jquery.nice-number/dist/jquery.nice-number.js");

export default {
  mounted() {
    jQuery(this.$el).niceNumber();

    jQuery(".nice-number")
      .find("button")
      .addClass("btn")
      .on("click", this.onChange);
  },
  methods: {
    onChange() {
      this.$emit("input", this.$el.value); // for v-model
    }
  }
};
</script>

<style scoped>
.nice-number {
  padding-top: 10px;
}
</style>